import React from "react";
import "./Pagination.scss";

export const Pagination = ({ limit, offset, totalRecords, onPageChange }) => {
  const safeLimit = Number(limit) || 1;
  const safeOffset = Number(offset) || 0;
  const safeTotalRecords = Number(totalRecords) || 0;
  const totalPages = Math.ceil(safeTotalRecords / safeLimit);
  const currentPage = Math.floor(safeOffset / safeLimit) + 1;

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(safeOffset - safeLimit);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(safeOffset + safeLimit);
    }
  };

  return (
    <div className="pagination-container">
      <button
        className="pagination-button"
        onClick={handlePrevious}
        disabled={currentPage === 1}
      >
        ⬅ Previous
      </button>

      <span className="pagination-info">
        Page {currentPage} of {totalPages}
      </span>

      <button
        className="pagination-button"
        onClick={handleNext}
        disabled={currentPage === totalPages || totalPages === 0}
      >
        Next ➡
      </button>
    </div>
  );
};
